// TODO use new commands

import { Injectable, inject } from '@angular/core';
import { BaseCommandRepository } from '../command-repository/command.repository';
import {
  AcceptFreightAssignationFromMarketCommand,
  AcceptFreightAssignationFromMarketCommandHandler,
  AddFreightCollaboratorInterestedCommand,
  AddFreightCollaboratorInterestedCommandHandler,
} from '@okcargo/command-processor';

@Injectable({ providedIn: 'root' })
export class FreightAvailableCommandService {
  private readonly commandRepository = inject(BaseCommandRepository);

  private readonly acceptFreightAssignationFromMarketCommandHandler: AcceptFreightAssignationFromMarketCommandHandler;
  private readonly addFreightCollaboratorInterestedCommandHandler: AddFreightCollaboratorInterestedCommandHandler;

  constructor() {
    const commandRepository = this.commandRepository;

    this.acceptFreightAssignationFromMarketCommandHandler = new AcceptFreightAssignationFromMarketCommandHandler(
      commandRepository,
    );
    this.addFreightCollaboratorInterestedCommandHandler = new AddFreightCollaboratorInterestedCommandHandler(
      commandRepository,
    );
  }

  public acceptFreightAssignationFromMarket(command: AcceptFreightAssignationFromMarketCommand): Promise<void> {
    return this.acceptFreightAssignationFromMarketCommandHandler.handle(command);
  }

  public addFreightCollaboratorInterested(command: AddFreightCollaboratorInterestedCommand): Promise<void> {
    return this.addFreightCollaboratorInterestedCommandHandler.handle(command);
  }
}
